export const WIX_SUPPORT = 'https://support.wix.com/'
export const FORMS_FEEDBACK = 'https://www.wixformsfeedback.com/'
export const REGISTRATION_FORM_FEEDBACK = 'https://www.wixformsfeedback.com/customregistration'
